// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"3505":"7aeec5c9","4131":"78d44809","6294":"0af98a8b"}[chunkId] || chunkId) + "." + {"3505":"063dd33bf3a79ed6","4131":"37a42840bf2ad17d","6294":"48186a737221048b","6340":"74e07860d3594402","6526":"3435940bcb2f8d41","7205":"42320ce7727d06c0","8245":"3e7e37cf190ef962"}[chunkId] + ".js";
};